import styled from "styled-components";

export const ProtocolFunctionsDiv = styled.div`
  margin: auto;
  padding: 16px;
  width: fit-content;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1.5px solid #fff;
  background-color: #e6e6e6;
  overflow-x: hidden;
`;
export const CloseDiv = styled.div`
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
export const CloseButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
`;
export const CloseImg = styled.img`
  width: 35px;
  height: 35px;
`;
export const FunctionsImg = styled.img``;
